// eslint-disable-next-line import/no-anonymous-default-export
export default {
  userManagement: {
    userDetail: "用户详情",
    updatePassword: "重置密码",
    password: "密码",
    associatedCompany: "关联公司",
    columns: {
      userName: "用户账号",
      email: "邮箱",
      phoneNumber: "电话",
      lastLoginedAt: "最后登录时间",
      lastModifiedAt: "最后修改时间",
    },
    searchPlaceholder: {
      userName: "请输入用户账号",
      phoneNumber: "请输入电话",
      email: "请输入邮箱",
    },
  },
};
